export default "__VITE_ASSET__8a91f1a2__"